import Api from '@/services/Api'
const path = 'foods'

export default {
    index(name, page) {
        return Api().get(path, {
            params: {
                name,
                page
            }
        })
    },
    show(id) {
        return Api().get(path + `/${id}`)
    },
    addUpdate(type) {
        return Api().post(path, type)
    },
    // delete(id) {
    //     return Api().delete(path + `/${id}`)
    // },
    delete(id) {
        return Api().get(path + `/delete/${id}`)
    },
    uploadImg(data) {
        return Api().post(path + '/uploadImg', data)
    },
    uploadIcon(data) {
        return Api().post(path + '/uploadIcon', data)
    },
}